import HTTP from './axios';

const PatientUserService = {
  register: user => HTTP.post('/register', user).then(response => response.data.data),
  update: user => HTTP.put('/patients', user).then(response => response.data.data),
  deactivate: (patientId, password) => HTTP.put(`/patients/${patientId}/deactivate`, { password }).then(response => response.data.data),
  uploadAvatar: (patientId, base64Image) => HTTP.post(`/patients/${patientId}/avatar`, { base64Image }).then(response => response.data.data),
  changePassword: (patientId, password, newPassword) => HTTP.put(`/patients/${patientId}/password`, { password, newPassword }).then(response => response.data.data),
  resetPassword: (token, phoneOrEmail, password) => HTTP.put('/resetPassword', { token, phoneOrEmail, password }).then(response => response.data.data),
  verify: code => HTTP.put('/verify', { code }).then(response => response.data.data),
};

export default PatientUserService;
